import React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import enImg from "../../Assets/images/us.png"
import arImg from "../../Assets/images/ar.png"
import frImg from "../../Assets/images/fr.png"

const languageMap = {
  en: { label: "English", dir: "ltr", active: true ,img:enImg},
  ar: { label: "العربية", dir: "rtl", active: false ,img:arImg },
  fr: { label: "Frensh", dir: "ltr", active: false, img:frImg },
};

const LanguageSelect = () => {
  const selected = localStorage.getItem("i18nextLng") || "en";
  const { t } = useTranslation();

  const [menuAnchor, setMenuAnchor] = useState(null);
  useEffect(() => {
    document.body.dir = languageMap[selected]?.dir;
  }, [menuAnchor, selected]);

  return (
    <div className="d-flex justify-content-end align-items-center language-select-root">
      <Button
        style={{
          color: "black",
          fontWeight: "bold",
          backgroundColor: "transperant",
        }}
        onClick={({ currentTarget }) => setMenuAnchor(currentTarget)}
      >
        <img
          src={languageMap[selected]?.img}
          alt={languageMap[selected]?.label}
          width="16"
          height="10"
          style={{ margin: "0 5px" }}
        />
        {languageMap[selected]?.label}
        <ArrowDropDown fontSize="small" />
      </Button>

       

      <Popover
        open={!!menuAnchor}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        style={{zIndex:"99999999999999"}}
      >
        <div>
          <List
            style={{
              backgroundColor: "white",
              color: "black",
            }}
          >
            {Object.keys(languageMap)?.map((item) => (
              <ListItem
                button
                key={item}
                onClick={() => {
                  i18next.changeLanguage(item);
                  setMenuAnchor(null);
                }}
              >
                 <img
                  src={languageMap[item]?.img}
                  alt={languageMap[item]?.label}
                  width="16"
                  height={languageMap[item]?.label=="العربية"?"16":"10"}
                  style={{ margin: "0 5px" }}
                />
                {languageMap[item]?.label}
              </ListItem>
            ))}
          </List>
        </div>
      </Popover>
    </div>
  );
};

export default LanguageSelect;
